import { CircularProgress } from '@mui/material';
import React from 'react';
import Container from './styles/Container';

type AbsoluteLoadingProps = {
  loading: boolean;
};

function AbsoluteLoading({ loading }: AbsoluteLoadingProps): JSX.Element | null {
  if (!loading) {
    return null;
  }

  return (
    <Container>
      <CircularProgress />
    </Container>
  );
}

export default AbsoluteLoading;
